import React from "react";
import { Tooltip } from "components/Atoms/Tooltip";
import { copyToClipboard } from "utilities/copyutils";

interface Props {
  classNames?: string;
  children: (copy: (value: string) => void) => React.ReactNode;
}

export const CopyToClipboardTooltip = (props: Props) => {
  const [isVisible, setIsVisible] = React.useState(false);
  const timeoutId = React.useRef<number>();

  const handleCopy = (value: string) => {
    copyToClipboard(value);
    setIsVisible(true);

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = window.setTimeout(() => {
      setIsVisible(false);
    }, 2000);
  };

  return (
    <Tooltip isVisible={isVisible} tooltipContent={RESX.GeneralLabels.CopiedToClipboard}>
      {props.children(handleCopy)}
    </Tooltip>
  );
}